import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";

import Tooltip from "ui-kit/Tooltip";
import { user as getUser } from "redux/modules/user/selectors";
import { Div } from "components/Base";

import { connect } from "react-redux";

import {
  HeaderNavSeparator,
  HeaderNavHelp,
  HeaderNavAvatar
} from "EventLight/Layout/View/Header";

const decorate = connect(state => ({
  user: getUser(state)
}));

class MyHeader extends Component {
  static propTypes = {
    params: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func
    }).isRequired,
    location: PropTypes.object.isRequired,
    myEvents: PropTypes.array.isRequired,
    showModal: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          backgroundColor: "#fff",
          width: "100%",
          justifyContent: "space-between",
          flexDirection: "row",
          alignItems: "center",
          borderBottom: "#efefef 1px solid",
          padding: "5px 60px",
          height: "65px;"
        }}
      >
        <Div display="row.flex-start.center">
          <Tooltip tooltip="View all my organizations" placement="bottom">
            <Link
              to="/home"
              style={{
                display: "flex"
              }}
            >
              <img
                src="https://d2ams66j58uyd5.cloudfront.net/images/sessionboard-square-logo.png"
                height={30}
              />
            </Link>
          </Tooltip>

          <Div
            fs={4}
            fw={4}
            ml={3}
            color="black"
            style={{
              fontSize: "20px"
            }}
          >
            Sessionboard
          </Div>
        </Div>

        <Div display="row.flex-end.center">
          <HeaderNavHelp />

          <HeaderNavSeparator />

          <HeaderNavAvatar user={this.props.user} />
        </Div>
      </div>
    );
  }
}

export default decorate(MyHeader);
